export var BaseRenderType;
(function (BaseRenderType) {
    BaseRenderType[BaseRenderType["BaseRender"] = 0] = "BaseRender";
    BaseRenderType[BaseRenderType["MeshRender"] = 1] = "MeshRender";
    BaseRenderType[BaseRenderType["ParticleRender"] = 2] = "ParticleRender";
    BaseRenderType[BaseRenderType["TrailRender"] = 3] = "TrailRender";
    BaseRenderType[BaseRenderType["LineRender"] = 4] = "LineRender";
    BaseRenderType[BaseRenderType["TerrainRender"] = 5] = "TerrainRender";
    BaseRenderType[BaseRenderType["SkyRender"] = 7] = "SkyRender";
    BaseRenderType[BaseRenderType["SimpleSkinRender"] = 8] = "SimpleSkinRender";
    BaseRenderType[BaseRenderType["SkinnedMeshRender"] = 9] = "SkinnedMeshRender";
})(BaseRenderType || (BaseRenderType = {}));
export var ENodeCustomData;
(function (ENodeCustomData) {
    ENodeCustomData[ENodeCustomData["custom_0"] = 0] = "custom_0";
    ENodeCustomData[ENodeCustomData["custom_1"] = 1] = "custom_1";
    ENodeCustomData[ENodeCustomData["custom_2"] = 2] = "custom_2";
})(ENodeCustomData || (ENodeCustomData = {}));
